var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"vapp"}},[_c('v-main',[_c('Transition',{attrs:{"name":"fade-transition","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }